import React from 'react';
import { Head } from './components/Head';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { TrustIndicators } from './components/TrustIndicators';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Head data-id="element-1" />
      <Navigation data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Services data-id="element-5" />
        <TrustIndicators data-id="element-6" />
        <Testimonials data-id="element-7" />
        <FAQ data-id="element-8" />
        <ContactForm data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}